import { Success as SuccessModal } from '@modals/layout'
import useTranslation from 'next-translate/useTranslation'

export const Success: React.FC = () => {
  const { t } = useTranslation('address-book/modals')

  return (
    <SuccessModal
      buttonText={t('common:done')}
      iconSize={58}
      message={t('addAddress.success.subtitle')}
      title={t('addAddress.success.title')}
    />
  )
}
